module.exports = __webpack_public_path__ + "static/media/pattern-1.20696cce.svg";